// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import * as axios from './http/http.js'
import httpConfig from './http/httpConfig'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/css/public.css'
import header from './components/public/Header'
import bottom from './components/public/Bottom'

Vue.component('m_header', header)
Vue.component('m_bottom', bottom)
Vue.use(ElementUI)

Vue.prototype.$axios = axios
Vue.prototype.$httpConf = httpConfig
Vue.prototype.$message = ElementUI.Message
Vue.prototype.$messageBox = ElementUI.MessageBox

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js